/* global s */
'use strict';

class Notifications {
	constructor(options) {
		this.defaults = {
			selectors: {
				subscribe_form_id: 'subscribe-form',
				subscribe_button_id: 'subscribe-button',
				subscribe_icon_id: 'subscribe-icon',
				subscribe_message_id: 'subscribe-message',
				notification_change_class: 'notification-change-toggle'
			}
		};
		this.options = Object.assign(this.defaults, options);
		this.pageEvents();
	}

	pageEvents() {
		let _this = this;
		const errorHandler = (input, errors, form, container) => {
			input.parentElement.insertAdjacentElement('afterend', container);
		};
		const constraints = {
			email: {
				presence: {
					message: '^' + s.options.messages.ERROR_PLEASE_ENTER_EMAIL
				},
				email: true,
			}
		};

		$(`#${this.options.selectors.subscribe_button_id}`).on('click', function () {
			let _toggle_ajax_data = {};
			let _information_form = $(this).closest('form');
			let _information_fields = _information_form.find('input, select, textarea, button').not(':hidden');
			const isFormValid = !new FormValidator({errorHandler, inputContainer:'js-form-group', isInvalid: 'error'}).ajaxValidate(_information_form[0], constraints);

			if (isFormValid || _information_form.hasClass('ignore-valid')) {
				$.each(_information_form.find('input, select, textarea, button'), function (i, field) {
					let _field_name = $(field).prop('name');
					let _field_value = $(field).val();
					if (!_field_name.match(/^(_nothing|_snowman|_token)/) && _field_name) {
						_toggle_ajax_data[_field_name] = _field_value;
					}
				});
				if (s.options.page_ajax.update_information) {
					s.options.page_ajax.update_information.abort();
				}
				_information_fields.prop({'disabled': true});
				s.options.page_ajax.update_information = $.ajax({
					url: s.url('/process_newsletter'),
					type: 'post',
					dataType: 'json',
					data: _toggle_ajax_data,
					success: function (response) {
						if (response) {
							let _subscribe_message = $(`#${_this.options.selectors.subscribe_message_id}`);
							let _subscribe_icon = $(`#${_this.options.selectors.subscribe_icon_id}`);
							if (_subscribe_message.length && _subscribe_icon.length) {
								_subscribe_icon.html(
									s.svg(
										['holder-circle-steps', 'subscribe--thanks'],
										'0 0 142 142',
										['color-responsive'],
										{},
										{},
										'',
										['', 'color-responsive-secondary']
									)
								);
								_subscribe_message.html(response[Object.keys(response)[0]]);
								_information_fields.hide();
								let _source = 'Welcome Email';
								try {
									if (window.location.search) {
										let searchParams = new URLSearchParams(window.location.search);
										_source = searchParams.get('source')
									}
								} catch(e) {
									console.log(`Search Params Error: ${e}`)
								}
								s.track.event(
									'Newsletter',
									('already_subscribed' in response && response.already_subscribed ? 'Already Subscribed' : 'Subscribe'),
									_source
								);
							} else {
								s.common.showPageMessage(response[Object.keys(response)[0]], Object.keys(response)[0]);
							}
						} else {
							s.common.showPageMessage(s.options.messages.ERROR_TRY_AGAIN, 'error');
						}
						_information_fields.prop({'disabled': false});
					},
					error: function() {
						s.common.showPageMessage(s.options.messages.ERROR_TRY_AGAIN, 'error');
						_information_fields.prop({'disabled': false});
					}
				});
			}
		});

		$(`.${this.options.selectors.notification_change_class}`).on('change', function () {
			if (s.options.page_ajax.notification_toggle) {
				s.options.page_ajax.notification_toggle.abort();
			}
			let _this = $(this);
			let _notification_type, _notification_preference;
			_notification_type = $(this).attr('name');
			if ($(this).is(':checked')) {
				_notification_preference = 'subscribe';
			} else {
				_notification_preference = 'unsubscribe';
			}
			s.options.page_ajax.notification_toggle = $.ajax({
				url: s.url('/process_notification'),
				type: 'post',
				dataType: 'json',
				data: {
					action: 'change_customer_subscription',
					notification_type: _notification_type,
					notification_preference: _notification_preference
				},
				success: function(response) {
					if (response) {
						if (response.status === 'successful') {
							s.common.showPageMessage(s.options.messages.CHANGES_SAVED_MESSAGE, 'success');
						} else {
							s.common.showPageMessage(s.options.messages.ERROR_TRY_AGAIN, 'error');
							if (_notification_preference === 'subscribe') {
								_this.prop('checked', false);
							}
							if (_notification_preference === 'unsubscribe') {
								_this.prop('checked', true);
							}
						}
					}
				},
				error: function() {
					s.common.showPageMessage(s.options.messages.ERROR_TRY_AGAIN, 'error');
					if (_notification_preference === 'subscribe') {
						_this.prop('checked', false);
					}
					if (_notification_preference === 'unsubscribe') {
						_this.prop('checked', true);
					}
				}
			});
		});
	}
}
